import { render, staticRenderFns } from "./TheReviewASubmittedDeathRecordForm.vue?vue&type=template&id=24856670&scoped=true&"
import script from "./TheReviewASubmittedDeathRecordForm.vue?vue&type=script&lang=js&"
export * from "./TheReviewASubmittedDeathRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./TheReviewASubmittedDeathRecordForm.vue?vue&type=style&index=0&id=24856670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24856670",
  null
  
)

export default component.exports